import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avt.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  // AiOutlineTwitter,
  // AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              ME <span className="purple"> PRESENTO </span>
            </h1>
            <p className="home-about-body">
            Soy Técnico Universitario en Desarrollo de Software, egresado en la<span className="purple"> UPATecO.</span>
              <br />
              Mi pasión por la programación, la tecnología, el diseño y la ilustración me ha llevado a especializarme y adquirir conocimientos en estas áreas.
              <br />
              <br />
              Me especializo en el diseño y desarrollo Front-End, utilizando tecnologías modernas como
              <br />
              <i>
                <b className="purple"> JavaScript, CSS, HTML, Python, Stack MERN </b>para crear interfaces dinámicas y atractivas.
              </i>
              <br />
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1> CONTÁCTAME </h1>
            <p>
              Puedes <span className="purple">contactarte </span> conmigo en.
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Nachzzz"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/jorge-ignacio-salto-0b29221bb"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
